// extracted by mini-css-extract-plugin
export default {"avatar-img":"styles_avatar-img__lnm+i","avatar-box":"styles_avatar-box__MG4AL"};